import { ApiBase } from '@/api/api'
import { makePostRequest } from '@/api/fetchCalls'
import { CompletePageConditionalRuleModel } from '@/domain/model/forms'

export const addNewCompletePageConditionalRules = async (
  data: Omit<CompletePageConditionalRuleModel, 'is_new'>[]
): Promise<void> => {
  return makePostRequest(ApiBase + '/workflows/redirect-rules', {
    body: JSON.stringify(data),
  })
}
